const en = {

    /* Language */
    "lang.ru": "RU",
    "lang.en": "EN",

    /* Menu */
    "menu.dashboard": "Dashboard",
    "menu.game": "Games",
    "menu.player": "Players",
    "menu.studio": "Studios",
    "menu.bonus": "Bonus",
    "menu.message": "Message",
    "menu.currency": "Currencies",
    "menu.card": "Cards",
    "menu.dealer": "Dealers",
    "menu.users": "Users",
    "menu.operators": "Operators",
    "menu.roles": "Roles",

    /* Header */
    "header.profile": "Profile",
    "header.changePassword": "Change password",
    "header.history": "Login history",
    "header.logout": "Logout",

    /* Auth */
    "auth.title": "Control Panel",
    "auth.password": "Password",
    "auth.login": "Login",
    "auth.error.emptyEmail": "Enter Email",
    "auth.error.invalidEmail": "Invalid Email format",
    "auth.error.emptyPassword": "Enter password",
    "auth.error.shortPassword": "Password must be at least 8 characters",
    "auth.error.invalidCredentials": "Invalid credentials!",
    "auth.error.userNotFound": "User not found!",
    "auth.error.wrongPassword": "Wrong password!",
    "auth.error.tooManyAttempts": "Too many login attempts! Try later.",
    "auth.error.generic": "Something went wrong! Try later.",

    /* Layout (full-page states) */
    "layout.serverError": "Server error!",
    "layout.serverErrorDesc": "Something went wrong! Try later.",
    "layout.networkError": "Connection error!",
    "layout.networkErrorDesc": "Check your network connection.",
    "layout.noAccess": "No access!",
    "layout.noAccessDesc": "You do not have access to view this data.",
    "layout.invalidKey": "Invalid key!",
    "layout.invalidKeyDesc": "The key seems to be expired! Reload the page or login again.",
    "layout.retry": "Retry",
    "layout.reload": "Reload",
    "layout.empty": "Nothing found!",
    "layout.emptyDesc": "Try again by changing filters.",

    /* Notes */
    "notes.empty": "No notes",
    "notes.title": "Notes",
    "notes.createError": "Failed to create note!",
    "notes.placeholder": "Write a message",

    /* DateFilter */
    "filter.selectDate": "Select date",
    "filter.selectDates": "Select dates",
    "filter.cancel": "Cancel",
    "filter.apply": "Apply",
    "filter.operators": "Operators",

    /* Pagination */
    "pagination.showing": "Showing",
    "pagination.of": "of",

    /* Cards */
    "cards.empty": "Empty",

    /* Transaction */
    "transaction.title": "Transaction info",
    "transaction.number": "Transaction number",
    "transaction.player": "Player",
    "transaction.name": "Name",
    "transaction.type": "Type",
    "transaction.time": "Time",
    "transaction.amount": "Amount",
    "transaction.status": "Status",
    "transaction.success": "Success",
    "transaction.error": "Error",
    "transaction.result": "Result",

    /* Time */
    "time.today": "Today",
    "time.todayComma": "Today, ",
    "time.yesterday": "Yesterday",
    "time.yesterdayComma": "Yesterday, ",
    "time.allTime": "All time",

    /* Days of week */
    "days.monday": "Monday",
    "days.tuesday": "Tuesday",
    "days.wednesday": "Wednesday",
    "days.thursday": "Thursday",
    "days.friday": "Friday",
    "days.saturday": "Saturday",
    "days.sunday": "Sunday",

    /* Permission */
    "permission.one": "access",
    "permission.few": "accesses",
    "permission.many": "accesses",

    /* Common */
    "common.add": "Add",
    "common.delete": "Delete",
    "common.edit": "Edit",
    "common.save": "Save",
    "common.cancel": "Cancel",
    "common.yes": "Yes",
    "common.no": "No",
    "common.name": "Name",
    "common.view": "View",
    "common.enabled": "Enabled",
    "common.disabled": "Disabled",
    "common.selectAll": "Select all",
    "common.clearAll": "Clear all",
    "common.generatePassword": "Generate password",
    "common.send": "Send",

    /* Common swal */
    "swal.deleteConfirm": "Do you really want to delete?",
    "swal.deleteWarning": "Cannot be restored after deletion",
    "swal.deleteButton": "Delete!",
    "swal.cancelButton": "Cancel",
    "swal.noAccess": "No access!",
    "swal.invalidKey": "Invalid key!",
    "swal.generic": "Something went wrong! <br /> Try later.",
    "swal.savedSuccess": "Data saved successfully!",
    "swal.deleteGame": "Delete game?",
    "swal.deleteGameWarning": "Cannot be restored after deletion.",
    "swal.cancelButton2": "Cancel",
    "swal.gameDeleted": "Game deleted!",
    "swal.settingsSaved": "Data saved successfully! <br /> Changes will appear<br /> after page refresh.",

    /* Settings widget */
    "settings.tableName": "Table name",
    "settings.tableKey": "Table key",
    "settings.gameLabel": "Game",
    "settings.gameURL": "Game URL",
    "settings.serverURL": "Server URL",
    "settings.type": "Type",
    "settings.image": "Image",
    "settings.currentDealer": "Current Dealer",
    "settings.enterName": "Enter table name",
    "settings.enterKey": "Enter table key",
    "settings.enterGame": "Enter game name",
    "settings.tokenCopied": "Token copied successfully!",
    "settings.save": "Save",

    /* Dashboard */
    "dashboard.filterAll": "All time",
    "dashboard.filterToday": "Today",
    "dashboard.filterWeek": "This week",
    "dashboard.filterMonth": "This month",
    "dashboard.filterYear": "This year",
    "dashboard.filterPeriod": "Period",
    "dashboard.hello": "Hello,",
    "dashboard.profit": "Profit (GGR)",
    "dashboard.visitors": "Visitors",
    "dashboard.players": "Players",
    "dashboard.rounds": "Rounds",
    "dashboard.games": "Games",
    "dashboard.notes": "Notes",
    "dashboard.activity": "Activity",
    "dashboard.transactions": "Transactions",
    "dashboard.gamesReport": "Games report",
    "dashboard.reportGameName": "Game name",
    "dashboard.reportPlayers": "Number of players",
    "dashboard.reportRounds": "Number of rounds",
    "dashboard.reportDebit": "Bet (DEBIT)",
    "dashboard.reportCredit": "Payout (CREDIT)",
    "dashboard.reportTotal": "Total",
    "dashboard.reportSheet": "Games report",
    "dashboard.playersWord1": "player",
    "dashboard.playersWord24": "players",
    "dashboard.playersWord5": "players",

    /* Game pages */
    "game.title": "Games",
    "game.add": "Add",
    "game.statistics": "Statistics",
    "game.currencies": "Currencies",
    "game.settings": "Settings",
    "game.parameters": "Parameters",
    "game.writeMessage": "Write message",
    "game.dealers": "Dealers",
    "game.gameNumber": "Game #",
    "game.connectionOk": "Connection established",
    "game.connectionFail": "Connection lost",
    "game.connecting": "Connecting...",
    "game.videoArchive": "Video archive",
    "game.addTitle": "Add game",
    "game.tableName": "Table name",
    "game.tableKey": "Table key",
    "game.gameURL": "Game URL",
    "game.serverURL": "Server URL",
    "game.tableStatuses": "Table statuses:",
    "game.tableVisibility": "Table visibility",
    "game.selectGame": "Select game",
    "game.error.emptyName": "Enter table name",
    "game.error.emptyKey": "Enter table key",
    "game.error.invalidKey": "Invalid value",
    "game.error.selectGame": "Select a game",
    "game.addedSuccess": "Game added successfully",

    /* Electron game widget - games list */
    "widget.searchByNumber": "Search by game number",
    "widget.playerID": "Player ID",
    "widget.to": "to",
    "widget.gameNumber": "Game number",
    "widget.dealer": "Dealer",
    "widget.players": "Players",
    "widget.status": "Status",
    "widget.date": "Date",
    "widget.operator": "Operator",
    "widget.winNumber": "Winning number",
    "widget.paused": "On pause",
    "widget.completed": "Completed",
    "widget.notCompleted": "Not completed",

    /* Game info widget */
    "widget.finishConfirm": "Do you really want to finish the game?",
    "widget.finishWarning": "Cannot be restored after changes",
    "widget.finishButton": "Yes, finish",
    "widget.finishSuccess": "Game finished successfully!",
    "widget.finishDone": "Finished successfully!",
    "widget.alreadyFinished": "Game already finished!",
    "widget.unknownError": "Unknown error! Please try again later.",
    "widget.gamePaused": "Game is on pause!",
    "widget.finishConfirmAlt": "Do you really want to finish the game?",
    "widget.finishWarningAlt": "Cannot be restored after completion",

    /* VipGame game info */
    "widget.game": "Game",
    "widget.gameStatus": "Game status",
    "widget.pauseStatus": "Pause status",
    "widget.changeStatus": "Change status",
    "widget.changed": "Changed",
    "widget.player": "Player",
    "widget.total": "Total",
    "widget.balanceBefore": "Balance before game",
    "widget.balanceAfter": "Balance after game",
    "widget.finishGame": "Finish game",
    "widget.finishAndRefund": "Finish and refund bet",
    "widget.pauseGame": "Pause game",
    "widget.resetCards": "Reset cards",
    "widget.continueWithout": "Continue without changes",
    "widget.pauseConfirm": "Do you really want to pause?",
    "widget.pauseWarning": "Game will be paused",
    "widget.pauseButton": "Yes, pause",
    "widget.alreadyPaused": "Game is already on pause!",
    "widget.gameFinished": "Game finished!",
    "widget.warningStatusDb": "Warning! Status changed only<br /> in database, since<br /> this is not the current game!",
    "widget.finishTxError": "Game is ended! Failed to complete transaction!",

    /* Refund */
    "widget.refundTitle": "Refund bet",
    "widget.payTitle": "Pay amount",
    "widget.totalBet": "Total bet",
    "widget.refunded": "Refunded",
    "widget.paid": "Paid",
    "widget.enterAmount": "Enter amount",
    "widget.pay": "Pay",
    "widget.amountError": "Enter amount",
    "widget.refundSuccess": "Refund completed successfully",
    "widget.paySuccess": "Payment completed successfully",
    "widget.refundTitle2": "Refund: ",
    "widget.payTitle2": "Payment: ",
    "widget.balance": "Balance",
    "widget.playerInfo": "Player information",
    "widget.rouletteNumber": "Number",
    "widget.rouletteBet": "Bet",
    "widget.rouletteWin": "Win",
    "widget.somethingWrong": "Something went wrong! Please try again later!",

    /* Statistics widget */
    "stats.players": "Number of Players",
    "stats.anteBets": "Number of ANTE bets",
    "stats.totalTime": "Total time",
    "stats.profit": "PROFIT:",
    "stats.avgAnte": "Average ANTE bet",
    "stats.combinations": "Combinations",
    "stats.period": "Statistics for period",
    "stats.day": "Day",
    "stats.week": "Week",
    "stats.month": "Month",
    "stats.statsFor": "Statistics for",
    "stats.testerWarning": "Warning! Statistics do not include tester data!",
    "widget.from": "from",

    /* Table Control widget */
    "control.bridgeConnected": "Connected to Bridge",
    "control.bridgeError": "Bridge error",
    "control.noGameConnection": "No connection to game!",
    "control.enterTime": "Enter time",
    "control.tableVisibility": "Table visibility",
    "control.makePublicHidden": "Make the table public or hidden",
    "control.tableFree": "Table is free",
    "control.tableBusy": "Table is busy",
    "control.autoDetect": "Detected automatically",
    "control.tableAccess": "Table access (open/close shift)",
    "control.allowDeny": "Allow or deny entry to table",
    "control.tableClosed": "Table is closed",
    "control.tableOpen": "Table is open",
    "control.allDay": "24/7",
    "control.allDayWork": "Round-the-clock operation",
    "control.workStart": "Work start time",
    "control.workEnd": "Work end time",

    /* Table Refunds widget */
    "refund.transactionNumber": "Transaction number",
    "refund.name": "Name",
    "refund.amount": "Amount",
    "refund.amountUSD": "Amount (USD)",
    "refund.admin": "Admin",
    "refund.dateTime": "Date and time",
    "refund.success": "Success",
    "refund.error": "Error",
    "refund.title": "Refunds",

    /* VipGame/MultiGame specific */
    "widget.finishConfirmBtn": "Finish",
    "widget.gamePausedSuccess": "Game paused",
    "widget.gameNotPaused": "Game is not paused!",
    "widget.continueConfirm": "Are you sure you want to continue?",
    "widget.continueText": "Game will continue without changes",
    "widget.gameContinued": "Game continued",
    "widget.resetCardsText": "Cards will be reset",
    "widget.cardsReset": "Cards reset",
    "widget.refundAllConfirm": "Are you sure you want to refund all bets?",
    "widget.refundAllWarning": "This action cannot be undone",
    "widget.refundAllBtn": "Yes, refund all",
    "widget.refundsComplete": "Refunds completed!",
    "widget.searchByPlayerNumber": "Search by player number",
    "widget.gameNumber2": "Game number",
    "widget.empty": "Empty",
    "widget.playersCount": "Number of players",
    "widget.transactionCount": "Number of transactions",
    "widget.allRefunds": "All refunds",
    "widget.refundAllBets": "Refund all bets",
    "widget.refundAllBetsAndPay": "Refund all bets and payments",
    "widget.continueGame": "Continue game",
    "widget.refundAndPayAllConfirm": "Are you sure you want to refund bets and payments for everyone?",
    "widget.allRefundsComplete": "All refunds completed!",
    "widget.operationConfirm": "Are you sure you want to perform this operation?",

    /* Studio Room */
    "studio.participantsTitle": "Participants",
    "studio.nameLabel2": "Name",
    "studio.disconnectStream": "Disconnect stream",

    /* Bonus Jackpot Connect/Update */
    "bonus.selectOperator": "Select operator",
    "bonus.cashLabel": "Cash, $",
    "bonus.visibility": "Visibility",
    "bonus.connect2": "Connect",
    "bonus.connectJackpotTitle": "Connect JACKPOT",
    "bonus.send": "Send",

    /* Player widget */
    "player.information": "General\u0020information",
    "player.sessions": "Sessions",
    "player.filter": "Filter",
    "player.operators": "Operators",
    "player.selectOperator": "Select at least 1 operator",
    "player.selectDates": "Select dates",
    "player.last3h": "Last 3 hours",
    "player.last6h": "Last 6 hours",
    "player.last12h": "Last 12 hours",
    "player.today": "Today",
    "player.yesterday": "Yesterday",
    "player.last7days": "Last 7 days",
    "player.last14days": "Last 14 days",
    "player.last30days": "Last 30 days",
    "player.thisMonth": "This month",
    "player.prevMonth": "Previous month",
    "player.allTime": "All time",
    "player.tester": "Tester",
    "player.player": "Player",
    "player.operator": "Operator",
    "player.rounds": "Number of rounds",
    "player.avgBet": "Average bet",
    "player.totalTime": "Total time",
    "player.selectPeriod": "Select period",
    "player.statsAll": "All\u00A0time",
    "player.statsDay": "Day",
    "player.statsWeek": "Week",
    "player.statsMonth": "Month",
    "player.statsPeriod": "Period",
    "player.roundCount": "Number of rounds",
    "player.report": "Players report",
    "player.reportName": "Player name",
    "player.reportCode": "Player code",
    "player.reportLastGame": "Last game",
    "player.reportOperator": "Operator",
    "player.reportCurrency": "Currency",
    "player.reportLastSession": "Last session",
    "player.reportSheet": "Players report",
    "player.title": "Players",
    "player.lastGame": "Last game",
    "player.currency": "Currency",
    "player.dateTime": "Date and time",
    "player.statsTitle": "Player statistics",
    "player.isTester": "Tester",
    "player.viewStats": "View statistics",
    "player.setTester": "Mark as tester",
    "player.removeTester": "Remove tester status",
    "player.search": "Search by name and code",
    "player.filterPeriod": "Period",
    "player.changeConfirm": "Do you really want to change?",
    "player.changeWarning": "This affects statistics",
    "player.statusChanged": "Status changed successfully",

    /* Admin pages */
    "admin.title": "Users",
    "admin.activity": "Activity",
    "admin.history": "Login history",
    "admin.changeAccess": "Change access",
    "admin.edit": "Edit",
    "admin.changePassword": "Change password",
    "admin.delete": "Delete",
    "admin.name": "Name",
    "admin.role": "Role",
    "admin.extendedAccess": "Extended access",
    "admin.createTitle": "Create user",
    "admin.editTitle": "Edit user",
    "admin.teamName": "Team name",
    "admin.selectRole": "Select role",
    "admin.addedSuccess": "User added successfully",
    "admin.deletedSuccess": "User deleted successfully",
    "admin.error.emptyName": "Enter your name",
    "admin.error.emptyEmail": "Enter Email",
    "admin.error.emptyTeam": "Enter team name",
    "admin.error.invalidEmail": "Invalid Email format",
    "admin.error.emptyPassword": "Enter password",
    "admin.error.shortPassword": "Password must be at least 8 characters",
    "admin.error.selectRole": "Select a role",
    "admin.passwordSaved": "Password saved successfully",
    "admin.historyTitle": "Login history",
    "admin.activityTitle": "Activity",
    "admin.changeAccessTitle": "Change access",
    "admin.newPassword": "New password",
    "admin.repeatNewPassword": "Repeat new password",
    "admin.device": "Device",
    "admin.browser": "Browser",
    "admin.ip": "IP address",
    "admin.country": "Country, City",
    "admin.lastActivity": "Last activity",
    "admin.game": "Game",
    "admin.action": "Action",
    "admin.dateTime": "Date and time",
    "admin.general": "General",

    /* Profile pages */
    "profile.title": "Profile",
    "profile.image": "Image",
    "profile.name": "Name",
    "profile.save": "Save",
    "profile.savedSuccess": "Data saved successfully",
    "profile.imageSaved": "Image saved successfully",
    "profile.imageDeleted": "Image deleted successfully",
    "profile.error.emptyName": "Enter name",
    "profile.changePassword": "Change password",
    "profile.currentPassword": "Current password",
    "profile.newPassword": "New password",
    "profile.repeatPassword": "Repeat password",
    "profile.error.emptyCurrentPwd": "Enter current password",
    "profile.error.shortCurrentPwd": "Password must be at least 8 characters",
    "profile.error.emptyNewPwd": "Enter new password",
    "profile.error.shortNewPwd": "Password must be at least 8 characters",
    "profile.error.mismatch": "Passwords do not match",
    "profile.passwordChanged": "Password changed successfully!",
    "profile.error.wrongPassword": "Wrong password!",
    "profile.error.authError": "Authorization error!",
    "profile.historyTitle": "Login history",
    "profile.device": "Device",
    "profile.browser": "Browser",
    "profile.ipAddress": "IP address",
    "profile.countryCity": "Country, City",
    "profile.lastActivity": "Last activity",

    /* Page 404 */
    "page404.text": "The page you requested does not exist.",

    /* Dealer pages */
    "dealer.title": "Dealers",
    "dealer.add": "Add",
    "dealer.name": "Name",
    "dealer.gamesCount": "Number of games",
    "dealer.qrCode": "QR code",
    "dealer.downloadPng": "Download .PNG",
    "dealer.edit": "Edit",
    "dealer.delete": "Delete",
    "dealer.addTitle": "Add dealer",
    "dealer.editTitle": "Edit data",
    "dealer.dealerName": "Dealer name",
    "dealer.error.emptyName": "Enter dealer name",
    "dealer.error.emptyPin": "Enter PIN/Barcode",
    "dealer.error.pinLength": "PIN/barcode length must be 6 characters",
    "dealer.addedSuccess": "Dealer added successfully",
    "dealer.savedSuccess": "Dealer saved successfully",
    "dealer.deletedSuccess": "Dealer deleted successfully",
    "dealer.added": "Dealer added",
    "dealer.removed": "Dealer removed",

    /* Currency pages */
    "currency.title": "Currencies",
    "currency.name": "Name",
    "currency.code": "Code",
    "currency.symbol": "Symbol",
    "currency.add": "Add",
    "currency.edit": "Edit",
    "currency.delete": "Delete",
    "currency.addTitle": "Add currency",
    "currency.editTitle": "Edit currency",
    "currency.symbolBefore": "Place symbol before number",
    "currency.error.emptyName": "Enter currency name",
    "currency.error.emptyCode": "Enter currency code",
    "currency.error.codeLength": "Code length must be 3 characters",
    "currency.error.emptySymbol": "Enter currency symbol",
    "currency.addedSuccess": "Currency added successfully",
    "currency.savedSuccess": "Currency saved successfully",
    "currency.deletedSuccess": "Currency deleted successfully",
    "currency.alreadyAdded": "Currency already added",
    "currency.selectCurrency": "Select currency",
    "currency.maxBet": "Maximum bet",
    "currency.maxBonusBet": "Maximum bonus bet",
    "currency.minBet": "Minimum bet",
    "currency.maxPay": "Maximum payout",
    "currency.chips": "Chips (comma separated)",
    "currency.maxPP": "Maximum PERFECT PAIR",
    "currency.max21": "Maximum 21+3",
    "currency.maxBust": "Maximum BUST",
    "currency.maxCS": "Maximum CRAZY SEVEN",
    "currency.maxBetShort": "Max. bet",
    "currency.minBetShort": "Min. bet",
    "currency.maxPayShort": "Max. payout",
    "currency.chipsLabel": "Chips",
    "currency.create": "Create",
    "currency.enterCurrency": "Select currency",
    "currency.enterMaxBet": "Enter maximum bet",
    "currency.enterMaxPP": "Enter maximum PERFECT PAIR",
    "currency.enterMax21": "Enter maximum 21+3",
    "currency.enterMaxBust": "Enter maximum BUST",
    "currency.enterMaxCS": "Enter maximum CRAZY SEVEN",
    "currency.enterMinBet": "Enter minimum bet",
    "currency.enterMaxPay": "Enter maximum payout",
    "currency.enterChips": "Enter chips list",

    /* Card pages */
    "card.title": "Cards",
    "card.name": "Name",
    "card.image": "Image",
    "card.value": "Value",
    "card.editBarcode": "Change BARCODE",
    "card.editTitle": "Change Barcode",
    "card.error.emptyBarcode": "Enter Barcode",
    "card.barcode": "Barcode",
    "card.savedSuccess": "Barcode saved successfully",

    /* Role pages */
    "role.title": "Roles",
    "role.name": "Name",
    "role.accessCount": "Number of accesses",
    "role.add": "Add",
    "role.edit": "Edit",
    "role.delete": "Delete",
    "role.addTitle": "Add role",
    "role.editTitle": "Edit role",
    "role.accessTo": "Access to",
    "role.error.emptyName": "Enter role name",
    "role.addedSuccess": "Role added successfully",
    "role.savedSuccess": "Role saved successfully",
    "role.deletedSuccess": "Role deleted successfully",

    /* Operator pages */
    "operator.title": "Operators",
    "operator.name": "Name",
    "operator.changeAccess": "Change access",
    "operator.edit": "Edit",
    "operator.delete": "Delete",
    "operator.createTitle": "Create operator",
    "operator.editTitle": "Edit operator",
    "operator.changeAccessTitle": "Change access for",
    "operator.error.emptyName": "Enter name",
    "operator.error.emptySlug": "Enter slug",
    "operator.error.emptySlugAlt": "Enter Slug",
    "operator.error.emptyStartpoint": "Enter Startpoint",
    "operator.error.emptyBalance": "Enter Balance URL",
    "operator.error.emptyDebit": "Enter Debit URL",
    "operator.error.emptyCredit": "Enter Credit URL",
    "operator.error.emptyWebhook": "Enter Webhook URL",
    "operator.addedSuccess": "Operator added successfully",
    "operator.savedSuccess": "Operator updated successfully",
    "operator.deletedSuccess": "User deleted successfully",

    /* Bonus page */
    "bonus.notFound": "Nothing found for your request",
    "bonus.operator": "Operator",
    "bonus.game": "Game",
    "bonus.player": "Player",
    "bonus.bet": "Bet",
    "bonus.win": "Win",
    "bonus.date": "Date",
    "bonus.info": "Information",
    "bonus.number": "Number",
    "bonus.gameNumber": "Game number #",
    "bonus.exchangeRate": "Exchange rate (to USD)",
    "bonus.combination": "Combination",
    "bonus.multiplier": "Multiplier",
    "bonus.cash": "Cash",
    "bonus.filter": "Filter",
    "bonus.operators": "Operators",
    "bonus.search": "Search by game number or player code",
    "bonus.title": "Bonus",
    "bonus.settings": "Settings",
    "bonus.games": "Games",
    "bonus.reset": "Reset",
    "bonus.jackpotNotConnected": "not connected",
    "bonus.connectJackpot": "Connect JACKPOT to operator",
    "bonus.connect": "Connect",
    "bonus.cashRegister": "CASH",
    "bonus.active": "Active",
    "bonus.disabled": "Disabled",
    "bonus.jackpotSettings": "JACKPOT Settings",

    /* Studio pages */
    "studio.title": "Studios",
    "studio.name": "Name",
    "studio.code": "Code",
    "studio.token": "Token",
    "studio.edit": "Edit",
    "studio.delete": "Delete",
    "studio.add": "Add",
    "studio.deleteConfirm": "Do you really want to delete the studio?",
    "studio.deleteWarning": "Cannot be restored after changes",
    "studio.deleteButton": "Yes, delete",
    "studio.deletedSuccess": "Studio deleted successfully!",
    "studio.createdTitle": "Create studio",
    "studio.editTitle": "Edit",
    "studio.savedSuccess": "Data saved successfully!",
    "studio.nameLabel": "Name",
    "studio.codeLabel": "Code",
    "studio.error.emptyName": "Enter name",
    "studio.error.emptyCode": "Enter code",
    "studio.error.emptyServiceURL": "Enter Service URL",
    "studio.error.emptySocketURL": "Enter Socket URL",
    "studio.createdSuccess": "Studio created successfully!",

    /* Studio stream */
    "studio.streams": "Streams",
    "studio.participants": "Participants",
    "studio.video": "Video",
    "studio.audio": "Audio",
    "studio.allTime": "All time",
    "studio.load": "Load",
    "studio.yes": "Yes",
    "studio.no": "No",

    /* Studio room (stream control) */
    "studio.disableStreamTitle": "Disable stream?",
    "studio.disableStreamText": "Do you really want to disable the stream?",
    "studio.disableStreamButton": "Disable",
    "studio.disabledSuccess": "Successfully disabled!",

    /* Message page */
    "message.title": "Message",
    "message.player": "Player",
    "message.game": "Game",
    "message.text": "Message",
    "message.dateTime": "Date and time",

    /* Notification page */
    "notification.title": "Notification",
    "notification.table": "Table",
    "notification.notification": "Notification",
    "notification.dateTime": "Date and time",
    "notification.new": "New",
    "notification.go": "Go",

    /* Support chat */
    "support.title": "Support",
    "support.inputPlaceholder": "Enter message...",
    "support.playerType": "Player",
    "support.adminType": "Admin",
    "support.noMessages": "No messages yet",
    "support.noMessagesDesc": "Support has not been contacted yet",
    "support.messageSent": "Message sent successfully",
    "support.messagePlaceholder": "Message",
    "support.emptyMessage": "Enter message",

    /* Table / Control widget */
    "table.bridgeConnected": "Connected to Bridge",
    "table.bridgeError": "Bridge error",
    "table.noGameConnection": "No connection to the game!",
    "table.save": "Save",
    "table.visibility": "Table visibility",
    "table.visibilityDesc": "Make the table public or hidden",
    "table.free": "Table is free",
    "table.busy": "Table is busy",
    "table.autoDetected": "Detected automatically",
    "table.access": "Table access (open/close shift)",
    "table.accessDesc": "Allow or deny entry to the table",
    "table.closed": "Table closed",
    "table.working": "Table is working",
    "table.allDay": "24/7",
    "table.allDayDesc": "Round-the-clock operation",
    "table.startTime": "Work start time",
    "table.endTime": "Work end time",
    "table.error.emptyStart": "Enter time",
    "table.error.emptyEnd": "Enter time",
    "table.deleteConfirm": "Delete game?",
    "table.deleteWarning": "Cannot be restored after deletion.",
    "table.deleteCancel": "Cancel",
    "table.deleteButton": "Delete",
    "table.deletedSuccess": "Game deleted!",

    /* Table / Dealer widget */
    "table.dealerAdded": "Dealer added",
    "table.dealerRemoved": "Dealer removed",

    /* Table / Refunds */
    "table.refundTxNumber": "Transaction number",
    "table.refundName": "Name",
    "table.refundAmount": "Amount",
    "table.refundAmountUSD": "Amount (USD)",
    "table.refundStatus": "Status",
    "table.refundAdmin": "Admin",
    "table.refundDateTime": "Date and time",
    "table.refundSuccess": "Success",

    /* Bonus widgets */
    "jackpot.notConnected": "JACKPOT not connected",
    "jackpot.connectDesc": "Connect JACKPOT to operator",
    "jackpot.connect": "Connect",
    "jackpot.cash": "CASH",
    "jackpot.active": "Active",
    "jackpot.disabled": "Disabled",
    "jackpot.settings": "JACKPOT settings",
    "jackpot.selectOperator": "Select operator",
    "jackpot.cashLabel": "Cash, $",
    "jackpot.visibility": "Visibility",
    "jackpot.connectButton": "Connect",

    /* Timezone */
    "timezone.title": "Select timezone",
    "timezone.confirmTitle": "Your timezone",
    "timezone.confirmText": "Detected from your device. Is it correct?",
    "timezone.yes": "Yes, correct",
    "timezone.change": "Change",

}

export default en
